module.exports = __webpack_public_path__ + "static/img/frachtwerk.b85a9a30.svg";